import { Result, Tag } from "antd/lib";
import styled from "styled-components";

export const ScannedResult = styled(Result)`
  .ant-result-title {
    font-size: 16px;
    font-weight: 300 !important;
  }

  .ant-result-subtitle {
    font-size: 20px;
    font-weight: 600 !important;
    color: #000;
  }
`;

export const ScannerResultTag = styled(Tag)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
  font-size: 16px;
  padding: 1em;
  border-radius: 10px;
  margin: ${(props) => (props.isMargin ? "4em 0" : "0")};
  font-weight: 600;
  svg {
    font-size: 20px;
  }
`;

export const ScannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
